export const BASE_THEMES_COLORS = {
  light: 'rgb(246, 246, 246)',
  dark: 'rgb(17, 17, 17)',
};
export const DEFAULT_THEME = 'light';
export const NAV_LIST_DROPDOWN_HIDE_DELAY = 0;
